export const RESET_CAPTCHA_REGISTRATION = 'RESET_CAPTCHA_REGISTRATION';
export const SET_BUSINESS_INFORMATION = 'SET_BUSINESS_INFORMATION';
